/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Vivid_Mole_WaveInputs */

const en_wild_vivid_mole_wave = /** @type {(inputs: Wild_Vivid_Mole_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const de_wild_vivid_mole_wave = /** @type {(inputs: Wild_Vivid_Mole_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Wild_Vivid_Mole_WaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wild_vivid_mole_wave = /** @type {((inputs?: Wild_Vivid_Mole_WaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Vivid_Mole_WaveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wild_vivid_mole_wave(inputs)
	return de_wild_vivid_mole_wave(inputs)
});